import { render } from "./indexScrollable.vue?vue&type=template&id=2b65c1e7"
import script from "./indexScrollable.vue?vue&type=script&lang=js"
export * from "./indexScrollable.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__